import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewServiceDefinitionVersionDetailsComponent } from './view-service-definition-version-details.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatDividerModule } from '@angular/material/divider';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { QuestionnaireSummaryModule } from '../questionnaire-summary/questionnaire-summary.module';
import { IconsModule } from 'src/app/icons/icons.module';


@NgModule({
  declarations: [
    ViewServiceDefinitionVersionDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,
    PipesModule,
    QuestionnaireSummaryModule,
    IconsModule
  ],
  exports: [
    ViewServiceDefinitionVersionDetailsComponent
  ]
})
export class ViewServiceDefinitionVersionDetailsModule { }

